import React from 'react';
import './Discussionpage.scss';

import ads5 from '../../assets/img/ads5.png';

import MustRead from '../../components/MustRead/Mustread';

export default class DiscussionPage extends React.Component {
    render() {
        return (
            <div className="astrology_page">

                <div className="container padding15">
                    <div className="row">
                        <div className="col">

                            <div className="news_widget_panel">
                                <div className="n_w_p_head">
                                    <h2><label>बहस</label></h2>
                                </div>
                                <div className="n_w_p_body">

                                    <ul className="disucsson_list">
                                        <li>
                                            <div className="discussion_panel">
                                                <div className="dis_p_head">
                                                    <h3>सामयिक</h3>
                                                </div>
                                                <div className="dis_p_body">
                                                केन्द्र की मोदी सरकार आंदोलनरत किसानों को एमएसपी पर हल क्यों नहीं निकल पा रहा फसल खरीदी की बात लिखित में क्यों नहीं दे रही?
                                                </div>
                                                <div className="dis_p_foot">
                                                    <span className="dis_comment_count">15</span>
                                                    <span className="dis_comment_date">Apr 10,2021</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="discussion_panel">
                                                <div className="dis_p_head">
                                                    <h3>सामयिक</h3>
                                                </div>
                                                <div className="dis_p_body">
                                                केन्द्र की मोदी सरकार आंदोलनरत किसानों को एमएसपी पर हल क्यों नहीं निकल पा रहा फसल खरीदी की बात लिखित में क्यों नहीं दे रही?
                                                </div>
                                                <div className="dis_p_foot">
                                                    <span className="dis_comment_count">15</span>
                                                    <span className="dis_comment_date">Apr 10,2021</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="discussion_panel">
                                                <div className="dis_p_head">
                                                    <h3>सामयिक</h3>
                                                </div>
                                                <div className="dis_p_body">
                                                केन्द्र की मोदी सरकार आंदोलनरत किसानों को एमएसपी पर हल क्यों नहीं निकल पा रहा फसल खरीदी की बात लिखित में क्यों नहीं दे रही?
                                                </div>
                                                <div className="dis_p_foot">
                                                    <span className="dis_comment_count">15</span>
                                                    <span className="dis_comment_date">Apr 10,2021</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="discussion_panel">
                                                <div className="dis_p_head">
                                                    <h3>सामयिक</h3>
                                                </div>
                                                <div className="dis_p_body">
                                                केन्द्र की मोदी सरकार आंदोलनरत किसानों को एमएसपी पर हल क्यों नहीं निकल पा रहा फसल खरीदी की बात लिखित में क्यों नहीं दे रही?
                                                </div>
                                                <div className="dis_p_foot">
                                                    <span className="dis_comment_count">15</span>
                                                    <span className="dis_comment_date">Apr 10,2021</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="discussion_panel">
                                                <div className="dis_p_head">
                                                    <h3>सामयिक</h3>
                                                </div>
                                                <div className="dis_p_body">
                                                केन्द्र की मोदी सरकार आंदोलनरत किसानों को एमएसपी पर हल क्यों नहीं निकल पा रहा फसल खरीदी की बात लिखित में क्यों नहीं दे रही?
                                                </div>
                                                <div className="dis_p_foot">
                                                    <span className="dis_comment_count">15</span>
                                                    <span className="dis_comment_date">Apr 10,2021</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="discussion_panel">
                                                <div className="dis_p_head">
                                                    <h3>सामयिक</h3>
                                                </div>
                                                <div className="dis_p_body">
                                                केन्द्र की मोदी सरकार आंदोलनरत किसानों को एमएसपी पर हल क्यों नहीं निकल पा रहा फसल खरीदी की बात लिखित में क्यों नहीं दे रही?
                                                </div>
                                                <div className="dis_p_foot">
                                                    <span className="dis_comment_count">15</span>
                                                    <span className="dis_comment_date">Apr 10,2021</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    
                                    

                                </div>
                            </div>

                        </div>
                        <div className="col right_side_bar">
                            <div className="ads_block m-b-15"><img src={ads5} /></div>
                            {/* <MustRead /> */}
                            <div className="m-b-15"></div>

                        </div>
                    </div>
                </div>

            </div>
        )
    }
}